import { render, staticRenderFns } from "./BiddingDetails.vue?vue&type=template&id=3cea738d&scoped=true&"
import script from "./BiddingDetails.vue?vue&type=script&lang=js&"
export * from "./BiddingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BiddingDetails.vue?vue&type=style&index=0&id=3cea738d&prod&lang=scss&scoped=true&"
import style1 from "./BiddingDetails.vue?vue&type=style&index=1&id=3cea738d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cea738d",
  null
  
)

export default component.exports